import {
  Compiler, Component, ComponentRef, Injector, Input, NgModule, NgModuleRef, OnDestroy, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ComponentsModule } from '../components.module';
const COMPONENT_FACTORY = 'ng-component';
@Component({
  selector: 'dynamic-message',
  templateUrl: './dynamic-message.component.html'
})
export class DynamicMessageComponent implements OnInit, OnDestroy {
  @Input() content: string;
  @ViewChild('messageContainer', { read: ViewContainerRef }) messageContainer: ViewContainerRef;

  private componentRef: ComponentRef<any>;

  constructor(private compiler: Compiler,
    private moduleRef: NgModuleRef<ComponentsModule>,
    private injector: Injector) {
  }

  ngOnInit() {
    this.createDynamicContent(this.content);
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  createDynamicContent(template: string) {
    const dynamicComponent = Component({ template })(class { });
    const dynamicModule = NgModule({
      declarations: [dynamicComponent],
      imports: [ComponentsModule]
    })(class { });
    this.compiler.compileModuleAndAllComponentsAsync(dynamicModule)
      .then((factories) => {
        const f = factories.componentFactories.find((ac => ac.selector === COMPONENT_FACTORY));
        this.componentRef = f.create(this.injector, [], null, this.moduleRef);
        this.messageContainer.insert(this.componentRef.hostView);
      });
  }

}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/dynamic-message/dynamic-message.component.ts